export default __webpack_public_path__ + "static/prolific_team-min-32d41b479b3e38516d298fea484d0d84.png";